// Load plugins
import Toastify from "toastify-js";

 // Attach to the window object
window.Toastify = Toastify;